import { mapState } from 'vuex';
import { Section } from '@styled/global';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var script = {
  props: {},
  data: function data() {
    return {
      height: 15
    };
  },
  mounted: function mounted() {
    this.calcHeight();
  },
  computed: _extends({}, mapState("viewport", ["breakpoint", "scroll"])),
  methods: {
    isMobile: function isMobile() {
      return this.breakpoint === "xs" || this.breakpoint === "sm";
    },
    isScrolled: function isScrolled() {
      return this.scroll.y > 4;
    },
    calcHeight: function calcHeight() {
      var targetHeightLookup = {
        xs: "89px",
        sm: "89px",
        md: "103px",
        lg: "107px",
        xl: "123px"
      };
      this.height = this.isMobile() || this.isScrolled() ? targetHeightLookup["sm"] : targetHeightLookup[this.breakpoint]; // console.log("height", this.height);
      // const fixedHeader = document.getElementById("fixedHeader");
      // var rect = fixedHeader.getBoundingClientRect();
      // console.log("fixedHeader", rect.height);
      // this.height = rect.height + "px";
    }
  },
  watch: {
    breakpoint: function breakpoint(newValue) {
      this.calcHeight();
    },
    scroll: function scroll(newValue) {
      this.calcHeight();
    }
  },
  render: function render() {
    var h = arguments[0];
    var height = this.height;
    return h(Section, {
      "style": {
        // background: "#007582",
        transition: "all 0.3s ease",
        height: height
      }
    });
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
